import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";

type TInput = {
  offerId: number;
};

type TOutput = {
  interestCount: number;
};

export default class GetOfferInterestApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;

  resolveUri({ offerId }: TInput): string {
    return `/fe-api/offer/interest-count/${offerId}?timestamp=${new Date().getTime()}`;
  }

  mapResponseData(_status: number, data: any): TOutput {
    return {
      interestCount: data.interest_count,
    };
  }
}
